import { Component } from '@angular/core';
import {
  ActivityStatus,
  ConsolidatedInspectionActivity,
  FormActivity
} from 'src/app/models/activities';
import { ActivityUtilities } from 'src/app/services/utilities/activities';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { applyNoScheduleOnlyCompleteStepFilter } from '../no-schedule-only-filter';

@Component({
  selector: 'wm-consolidated-inspection-activity-view',
  templateUrl: './consolidated-inspection-activity-view.component.html',
  styleUrl: './consolidated-inspection-activity-view.component.css',
  standalone: false
})
export class ConsolidatedInspectionActivityViewComponent extends ActivityView {
  activity: ConsolidatedInspectionActivity;

  requestStepVisible = false;
  scheduleStepVisible = false;

  ActivityStatus = ActivityStatus;

  constructor() {
    super();
  }

  ngOnInit() {
    const convertedActivities = ActivityUtilities.convertActivitiesJsonToClasses(
      [
        this.activity.model.requestStepActivity,
        this.activity.model.scheduleStepActivity,
        this.activity.model.completeStepActivity
      ]
    );

    this.activity.model.requestStepActivity = convertedActivities[0] as FormActivity;
    this.activity.model.scheduleStepActivity = convertedActivities[1] as FormActivity;
    this.activity.model.completeStepActivity = convertedActivities[2] as FormActivity;

    applyNoScheduleOnlyCompleteStepFilter(this.activity);

    this.requestStepVisible = this.activity.requestStepSubmitted;
    this.scheduleStepVisible =
      this.activity.scheduleStepSubmitted &&
      this.activity.responsibleForSchedule;
  }
}
